module.exports = __webpack_public_path__ + "static/media/image3.f6aad8e8.jpg";